import { render, staticRenderFns } from "./NewMinorConfigModal.vue?vue&type=template&id=edb3277c&scoped=true"
import script from "./NewMinorConfigModal.vue?vue&type=script&lang=js"
export * from "./NewMinorConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb3277c",
  null
  
)

export default component.exports